import * as React from 'react';

import TransactionForm from 'components/forms/TransactionForm';
import ContentWrapper from 'components/ContentWrapper';

const ConversionTransactionEditScreen = () => (
  <ContentWrapper>
    <TransactionForm editType transactionType="conversion" />
  </ContentWrapper>
);

export default ConversionTransactionEditScreen;
